// extracted by mini-css-extract-plugin
export default {"menu":"TkWRwECQVWV3FuDIdXR7","item":"RaWo3bfVwsVf3dkXsgcg","active":"Lmw2MZuJTG8MSI4Wmm1_","heading":"oswzmiwUVaUUGRyxsjF_","heading__title":"OlV1v_wjVknPVgvzmZdo","text":"ub8F_V8go46u57IYjHVI"};
    if(module.hot) {
      // 1719312944673
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  